import styled from '@emotion/styled/macro';

import StatusMessage from '../../../../../../../components/UI/StatusMessage/StatusMessage';

export const StyledStatusMessage = styled(StatusMessage)`
  margin-top: 1rem;
`;
